/**
 * DEPRECATED: Remove after no longer needed, currently only used by resource-center
 */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex } from '@rebass/grid';
import { media, getThemeProp } from '@amtrav/themes';
import Content from './Content';

// TASK: Removed hard-coded styles
export const PageHeaderRegion = styled.div`
  background: ${getThemeProp('global.pageHeaderBackground--color')};
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  align-items: center;

  ${media.Large`
    height: 78px;
  `}
`;

const ContentStyled = styled.div`
  flex-grow: 1;
`;

PageHeaderRegion.Wrapper = styled(Flex)`
  flex-direction: column;

  @media (min-width: 960px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

PageHeaderRegion.Title = styled.h1`
  font-weight: 800;
  font-size: 20px;
  margin: 0;

  ${media.Large`
    font-size: 24px;
  `}
`;

PageHeaderRegion.Aside = styled.div`
  flex-basis: 40%;
  display: flex;

  ${media.Large`
    padding: 0;
    text-align: right;
    justify-content: flex-end;
  `};
`;

const PageHeader = ({ title, aside }) => (
  <PageHeaderRegion>
    <ContentStyled>
      <Content>
        <PageHeaderRegion.Wrapper px={[2, 2, 2, 4]} py={[3, 3, 3, 0]}>
          <PageHeaderRegion.Title>{title}</PageHeaderRegion.Title>
          <PageHeaderRegion.Aside>{aside}</PageHeaderRegion.Aside>
        </PageHeaderRegion.Wrapper>
      </Content>
    </ContentStyled>
  </PageHeaderRegion>
);

PageHeader.propTypes = {
  title: PropTypes.string,
  aside: PropTypes.node,
};

export default PageHeader;
